/**
 * @param {number} associatedStepNumber - The number of the step that this review section is associated with
 * @param {function} changeStep         - Callback function to change the current step
 * @param {React.ReactNode} children   - Child JSX components
 * @param {string} title                - Title of the review section
 *
 * @returns {JSX.Element} 				        - The property type component.
 */
export default function ReviewSection({
  associatedStepNumber = 0,
  changeStep = () => {},
  children,
  edit = true,
  title,
}) {
  return (
    <div className="mb-4">
      <h5 className="mb-2 font-bold">
        {title}
        {edit && (
          <span
            onClick={() => changeStep(associatedStepNumber)}
            className="ml-2 text-sm text-blue-600 hover:cursor-pointer hover:underline"
          >
            Edit
          </span>
        )}
      </h5>
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
